export default __webpack_public_path__ + "static/media/authImg3.03fe2c01.jpg";